export default "__VITE_ASSET__c02f6ea9__"